import { generateMdiIcon, heliosDefaultColWidth } from '@helios/ag-grid-config'
import {
  ColDef,
  ICellRendererParams,
  ITooltipParams,
} from '@ag-grid-community/core'
import { FilterOptionDef } from '@northfork/ag-grid-angular'

export const TRADING_MATCHED_COLOR = '#f26627'
export const CUSTODY_MATCHED_COLOR = '#5589c5'

export const transactionMatchCountCellRender = (
  params: ICellRendererParams,
) => {
  if (params.value == null || params.value === 0) {
    return generateMdiIcon('mdi-link-off', ['text-muted'])
  }
  return `${generateMdiIcon('mdi-link')} ${params.value}`
}

export const transactionMatchCountTooltipValueGetter = (
  params: ITooltipParams,
) => {
  return params.value ? `There are ${params.value} matches.` : ''
}

export const TransactionMatchCountColDef: ColDef = {
  width: heliosDefaultColWidth.LargeIcon,
  tooltipValueGetter: transactionMatchCountTooltipValueGetter,
  cellRenderer: transactionMatchCountCellRender,
  sortable: true,
  filter: 'number',
  filterParams: {
    suppressAndOrCondition: true,
    closeOnApply: true,
    filterOptions: [
      'equals',
      {
        displayKey: 'blank',
        displayName: 'Unmatched',
        test: () => false, //NOOP server side
        numberOfInputs: 0,
      } as FilterOptionDef<string>,
      {
        displayKey: 'notBlank',
        displayName: 'Matched',
        test: () => false, //NOOP server side
        numberOfInputs: 0,
      } as FilterOptionDef<string>,
    ],
  },
}
